import { Star } from 'lucide-react'

interface RatingStarsProps {
	rating: number
	size?: 'sm' | 'md' | 'lg'
}

const RatingStars: React.FC<RatingStarsProps> = ({ rating, size = 'md' }) => {
	const sizeMap = {
		sm: 14,
		md: 18,
		lg: 22,
	}

	const starSize = sizeMap[size]

	return (
		<div className='flex items-center gap-0.5'>
			{[1, 2, 3, 4, 5].map((starIndex) => {
				const fillPercentage = Math.max(
					0,
					Math.min(100, (rating - starIndex + 1) * 100)
				)

				return (
					<div
						key={starIndex}
						className='relative transition-all duration-300 hover:scale-110'
					>
						<Star size={starSize} className='text-gray-200 drop-shadow-sm' />
						<div
							className='absolute top-0 left-0 overflow-hidden transition-all duration-500'
							style={{ width: `${fillPercentage}%` }}
						>
							<Star
								size={starSize}
								className='text-red-600 fill-current drop-shadow-md'
							/>
						</div>
					</div>
				)
			})}
		</div>
	)
}

export default RatingStars
